import {
  Text,
  type TypographyProps,
} from '@medsimples/design-system/src/chakra';
import { format } from 'date-fns';

export interface CountdownProps {
  count: number;
  fontSize?: TypographyProps['fontSize'];
}

export default function Countdown(props: CountdownProps) {
  const getDate = (seconds: number) => {
    const d = new Date(0);
    d.setMilliseconds(seconds);
    return format(d, 'mm:ss');
  };

  return (
    <Text
      display={'inline-block'}
      textAlign='justify'
      fontSize={props.fontSize ?? 'lg'}
    >
      {props.count ? getDate(props.count) : ''}
    </Text>
  );
}
